export default __webpack_public_path__ + "static/media/credit-limit.5b98e727.svg";